import { PTCMetadata } from '@api/consumerloans-public-api';
import { BaseSessionInfo } from '@types';

export const getServiceInputMetadata = (sessionInfo: BaseSessionInfo): PTCMetadata => {
	return {
		application: sessionInfo.application,
		geo: sessionInfo.geo,
		languageCode: sessionInfo.language.toLowerCase(),
		targetSystem: sessionInfo.targetSystem,
	};
};
